import React, { Component } from 'react'
import { Modal, Radio, message, Select, Upload, Button } from 'antd';
import $, { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import Text from '../../../basicElement/Text';
import ExportUtil from '../../../../common/ExportUtil';

const { Option } = Select; 

export default class UpdateWord extends Component {
    state = {
        visible: false,
        data: {},
        saveParams: {},
        fileList: [],
        PMWord: {},
        CODWord: {},
    }

    show = () => {
        this.setState({ visible: true },this.loadData);
    }

    handleData = (data = []) => {
        let { PMWord, CODWord } = this.state;
        PMWord = {...data.find( el => el.roleCode === 'PM' )}
        CODWord = {...data.find( el => el.roleCode === 'CSA' )}
        this.setState({ PMWord, CODWord, data })
    }

    loadData = () => {
        const options = {
            url: API_URL.contract.queryContractGuideFileMate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.handleData( res.contractGuideFileMates )
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }  

    handleOk = () => {
        const { saveParams, fileList } = this.state;
        if( !saveParams.roleCode ) {
            message.error('请选择适应角色！')
            return
        }else if( !fileList.length ){
            message.error('请选择上传附件！')
            return
        }
        let idx = 0;
        for (let i = 0; i < fileList.length; i++) {
            const { response, deletable } = fileList[i];
            if (!response) {
                message.warning('文件上传中，请稍后！');
                return;
            }
            if (deletable === false) {
                continue;
            }
            saveParams[`fileMateId`] = response.fileMetaId;
        }
        const options = {
            url: API_URL.contract.addContractGuideFileMate,
            data: {
                ...saveParams
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success)
                this.handleCancel()
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }
    
    handleCancel = () => {
        this.setState({
            visible: false,
            data: {},
            saveParams: {},
            fileList:[],
        });
    }

    beforeUpload = file => {
        const isLt30M = (file.size / 1024 / 1024) < 30;
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleSelectChange = ( value, key) =>{
        const saveParams = {};
        saveParams[key] = value
        this.setState({ saveParams })
    }

    handleUploadChange = (info) => {
        const fileList = info.fileList.filter((file,index) => {
            const { status, response } = file;
            if (status === 'error') {
                message.error('上传附件失败');
                return false;
            } else if (status === 'done') {
                if (response.error) {
                    message.error(response.error);
                    return false;
                } else if(index == info.fileList.length-1){
                    message.success(response.success);
                    return true;
                }
            }
            return true;
        });
        this.setState({ fileList });
    }

    download = fileMetaId => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    render() {
        const { visible, saveParams, data, PMWord, CODWord, fileList } = this.state;
        return (
            <Modal
                title="上传文档"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="updataWord" >
                    <p className="tip">注：此处上传的是项目关闭流程文档（只保留最新文档）</p>
                    <div className="form-list">
                        <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text asterisk={true} colon={true}>适应角色</Text></label>
                            <div className='ui-text'>
                                <Select
                                    placeholder="请选择"
                                    style={{width: 80}}
                                    onChange={value => this.handleSelectChange(value, 'roleCode')}
                                    value={saveParams.roleCode}
                                    allowClear={true}
                                >
                                    <Option key={'PM'} value={'PM'}>PM</Option>
                                    <Option key={'CSA'} value={'CSA'}>CSA</Option>
                                </Select>
                            </div>
                        </div>
                        <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text asterisk={true} colon={true}>上传附件</Text></label>
                            <div className='ui-text'>
                                <Upload
                                    action={API_URL.contract.uploadJdeCodeEnclosure}
                                    fileList={fileList}
                                    data={{
                                        uploadType: 'CONTRACT_GUIDE',
                                        path: Date.now(),
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                    }}
                                    beforeUpload={this.beforeUpload}
                                    onChange={this.handleUploadChange}
                                    headers={xToken}
                                >
                                    <Button disabled={!saveParams.roleCode} style={{ width: 80 }}>选择文件</Button>
                                </Upload>
                            </div>
                        </div>
                        <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text colon={true}>PM关闭流程指引文档下载</Text></label>
                            <div className='ui-text'>
                                <a onClick={ () => this.download(PMWord.fileMateId) }>{PMWord.name}</a>
                            </div>
                        </div>
                        <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text colon={true}>CSA关闭流程指引文档下载</Text></label>
                            <div className='ui-text'>
                                <a onClick={ () => this.download(CODWord.fileMateId) }>{CODWord.name}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/UpdateWord.js